import { Injectable } from "@angular/core";
import { ConnectionService } from "../connection/connection.service";
import { AppConstants } from "../../entity/constants";

@Injectable({
  providedIn: "root",
})
export class RouteOptimizationService {
  constructor(private readonly connectionService: ConnectionService) {}

  getRouteOptimization(routeId: string) {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${routeId}/${AppConstants.OPTIMIZATION_DETAILS}`,
      directoryType: AppConstants.DP,
      isLoader: true
    });
  }
}
